// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__JPiX8","resultsStats":"styles_resultsStats__pEBNa"};